/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

//  Phaser.Physics.Matter.Body.Components

module.exports = {

    Bounce: require('./Bounce'),
    Collision: require('./Collision'),
    Force: require('./Force'),
    Friction: require('./Friction'),
    Gravity: require('./Gravity'),
    Mass: require('./Mass'),
    Static: require('./Static'),
    Sensor: require('./Sensor'),
    SetBody: require('./SetBody'),
    Sleep: require('./Sleep'),
    Transform: require('./Transform'),
    Velocity: require('./Velocity')

};



//////////////////
// WEBPACK FOOTER
// ./physics/matter-js/components/index.js
// module id = 161
// module chunks = 0